import { isUndefined } from "lodash";
import { createContext, useContext } from "react";
import AccountAPI from "../lib/account";
import AuthAPI from "../lib/auth";
import BuoyAPI from "../lib/buoy";
import IntegrationAPI from "../lib/integration";
import InvoiceAPI from "../lib/invoices";
import SubscriptionAPI from "../lib/subscription";
import useAuth from "./AuthContext";

interface IApiContext {
	account: AccountAPI;
	integration: IntegrationAPI;
	subscription: SubscriptionAPI;
	buoy: BuoyAPI;
	auth: AuthAPI;
	invoice: InvoiceAPI;
}

const ApiContext = createContext<IApiContext | undefined>(undefined);

export function ApiContextProvider(props: { children?: React.ReactNode }) {
	const { token } = useAuth();
	const account = new AccountAPI(token ?? "");
	const integration = new IntegrationAPI(token ?? "");
	const subscription = new SubscriptionAPI(token ?? "");
	const buoy = new BuoyAPI(token ?? "");
	const auth = new AuthAPI(token ?? "");
	const invoice = new InvoiceAPI(token ?? "");

	return (
		<ApiContext.Provider
			value={{
				account,
				integration,
				subscription,
				buoy,
				auth,
				invoice,
			}}
		>
			{props.children}
		</ApiContext.Provider>
	);
}

export function useApi() {
	const context = useContext(ApiContext);
	if (isUndefined(context)) {
		throw new Error("useApi must be used within a ApiContextProvider");
	}
	return context;
}
